const ensureTooltip = function (el, bootstrapObj) {
  const bs = bootstrapObj || window.bootstrap
  if (!el || !bs || !bs.Tooltip) return null
  return bs.Tooltip.getOrCreateInstance(el)
}

const ensureDropdown = function (el, bootstrapObj) {
  const bs = bootstrapObj || window.bootstrap
  if (!el || !bs || !bs.Dropdown) return null
  return bs.Dropdown.getOrCreateInstance(el)
}

const applyMod2ShortcutTooltips = function ($body, shortcuts, bootstrapObj) {
  const bs = bootstrapObj || window.bootstrap
  const safeList = Array.isArray(shortcuts) ? shortcuts : []
  if (!$body || typeof $body.find !== 'function') return
  safeList.forEach(function (item) {
    const selector = String(item && item.selector ? item.selector : '').trim()
    const shortcutRaw = String(item && item.shortcut ? item.shortcut : '').trim()
    if (!selector || !shortcutRaw) return
    const shortcut = shortcutRaw.toUpperCase()
    $body.find(selector).filter('.btn-portal--mod2').each(function () {
      const $el = window.jQuery(this)
      const currentTitle = String($el.attr('data-bs-title') || $el.attr('title') || '').trim()
      if (!currentTitle) return
      const baseTitle = String($el.attr('data-shortcut-base-title') || currentTitle).trim()
      $el.attr('data-shortcut-base-title', baseTitle)
      const nextTitle = baseTitle + ' (' + shortcut + ')'
      $el.attr('data-bs-title', nextTitle)
      $el.attr('title', nextTitle)
      const tooltipInstance = (bs && bs.Tooltip) ? bs.Tooltip.getInstance(this) : null
      if (tooltipInstance) {
        tooltipInstance.dispose()
      }
    })
  })
}

const isTypingContext = function (target, docRef) {
  const doc = docRef || document
  const el = target instanceof HTMLElement ? target : doc.activeElement
  if (!el) return false
  if (el.isContentEditable) return true
  const tag = String(el.tagName || '').toUpperCase()
  if (['INPUT', 'TEXTAREA', 'SELECT', 'OPTION'].includes(tag)) return true
  return !!el.closest('[contenteditable="true"], .swal2-input, .swal2-textarea')
}

const parseShortcut = function (shortcut) {
  const raw = String(shortcut || '').trim()
  if (!raw) return null
  const tokens = raw.split('+').map((part) => String(part || '').trim().toUpperCase()).filter(Boolean)
  if (!tokens.length) return null
  const keyToken = tokens[tokens.length - 1]
  return {
    ctrl: tokens.includes('CTRL') || tokens.includes('CONTROL'),
    shift: tokens.includes('SHIFT'),
    alt: tokens.includes('ALT'),
    meta: tokens.includes('META') || tokens.includes('CMD') || tokens.includes('COMMAND'),
    key: keyToken
  }
}

const normalizeEventKey = function (event) {
  const key = String((event && event.key) || '').trim()
  if (!key) return ''
  const upper = key.toUpperCase()
  if (upper === 'ESC') return 'ESCAPE'
  if (upper === ' ') return 'SPACE'
  return upper
}

const eventMatchesShortcut = function (event, parsed) {
  if (!event || !parsed) return false
  if (!!event.ctrlKey !== !!parsed.ctrl) return false
  if (!!event.shiftKey !== !!parsed.shift) return false
  if (!!event.altKey !== !!parsed.alt) return false
  if (!!event.metaKey !== !!parsed.meta) return false
  return normalizeEventKey(event) === parsed.key
}

export {
  ensureTooltip,
  ensureDropdown,
  applyMod2ShortcutTooltips,
  isTypingContext,
  parseShortcut,
  normalizeEventKey,
  eventMatchesShortcut
}
